module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?7a44ea195f395e1d086010e44555a5c4";